import { useEffect, useState } from 'react';
import pinstarLogo from '../../img/pinstar.png'
import { textStatusType, cardStatusType } from '../shared/helpers';
import ASRVPcard from './ASRVP-Card';
const ASRVPMembership = (props) => {
    const [textBSColor, setTextBSColor] = useState();

    useEffect(()=>{
        if(props?.model?.membershipCompliance?.statusColor){
            setTextBSColor(textStatusType(props?.model?.membershipCompliance?.statusColor));
        }
    },[props]);

    return (
        <>
            <ASRVPcard
                text={"Everyone involved in the program is required to be a USBC Member"}
                image={
                    <a href="http://www.Bowl.com" target="_blank" rel="noopener noreferrer">
                        <img className="asrvp-pinstar-logo asrvp-logo" src={pinstarLogo} atl="United States Bowling Congress" />
                    </a>
                }
                imageText={"United States Bowling Congress"}
                statusText={
                    <div>
                        <div className={'text-center fw-bold ' + textBSColor}>
                            {props?.model?.membershipCompliance?.seasonMessageLine1}
                        </div>
                        <div className={'text-center fw-bold ' + textBSColor}>
                            {props?.model?.membershipCompliance?.seasonMessageLine2}
                        </div>
                        {props?.model?.membershipCompliance?.seasonMessageLine3 && props?.model?.membershipCompliance?.suspended === false &&
                            <div className={'text-center fw-bold ' + textBSColor}>
                            {props?.model?.membershipCompliance?.seasonMessageLine3}
                        </div>}
                        {props?.model?.membershipCompliance?.seasonMessageLine3 && props?.model?.membershipCompliance?.suspended === true &&
                            <span className={'text-center fw-bold ' + textBSColor}>
                            {props?.model?.membershipCompliance?.seasonMessageLine3} <a className="fw-bold" href="mailto:Rules@bowl.com?subject=Rules%20Question" target="_blank" rel="noopener noreferrer">Rules@bowl.com</a>
                        </span>}
                    </div>
                }
                cardStatusType={cardStatusType(textBSColor)}
            >
                {/* Children */}
                {props?.model?.membershipCompliance?.showJoinButton && <a href={process.env.REACT_APP_JOIN_URL} className='btn btn-danger mt-3' type="button">Join</a>}
                {props?.model?.membershipCompliance?.showLinkMembershipButton && <a href={process.env.REACT_APP_MEMBERSHIP_LINK_URL} className='btn btn-primary mt-3' type="button">Link Membership</a>}
            </ASRVPcard>
        </>
    );
}

export default ASRVPMembership;